import { useSearchParams } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
import { useState } from 'react';
import { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
	fetchStudies,
} from '../api/studiesAPI';
import AuthContext from '../store/auth-context';
import WrapperModal from '../components/ui/WrapperModal';
import NewHospitalForm from '../components/forms/NewHospitalForm'
import ConfirmationWarning from '../components/ui/ConfirmationWarning';
import Pagination from '../components/mainDashboard/Pagination';
import DashboardHeader from '../components/mainDashboard/DashboardHeader';
import Button from '../components/ui/Button';
import Loader from '../components/ui/Loader';

import './PIDashboard.scss';
import { AccessibilityContext } from '../store/accesibility-context';
import HospitalTable from '../components/hospitalDashboard/HospitalTable';
import { getHospitalslist } from '../api/superAPI';
const HospitalPage = () => {
	const accessibilityCtx = useContext(AccessibilityContext);
	const [pageNumber, setPageNumber] = useState(1);

	const [currentOption, setCurrentOption] =
		useState('none');
	const [searchParams] = useSearchParams();
	const q = searchParams.get('q');

	const hospitalsListQuery = useQuery({
		queryKey:['hospitals-list'],
		queryFn: getHospitalslist,
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	})
	const [showAddHospital, setAddHospital] = useState(false);
	const [confirmationModal, setConfirmationModal] = useState(false)
	
	const [addStudyStep, setAddStudyStep] = useState('');

	const cancelCreationHandler = () => {
		setAddHospital(false);
		setConfirmationModal(false)
	};

	const dispatch = useDispatch();
	if (hospitalsListQuery.isLoading) return <Loader/>;
	
	// const onPageChange = (targetPageNumber) => {
	// 	setPageNumber(targetPageNumber);
	// 	queryClient.invalidateQueries('studies');
	// };

	const addNewHospitalHandler = () => {
		setAddHospital('CONFIRM_CREATION');
	}
	

	return (
		<div className='dashboard-general-wrapper'>
			<DashboardHeader />
			{/* TODO create a DashboardContent component and migrate all grid elements, controls an pagination there */}
			<div className='dashboard-content-container'>
				<div className='content-header'>
					<div className='content-title'>
						<h2>Hospitals</h2>
					</div>
                    <div className='content-controls'>
                        <Button
                            onClick={() => addNewHospitalHandler(true)}
                            className={`${accessibilityCtx.contrast === false ?'primary-button' : 'primary-button-contrast'} 'create-study-buttons new-study-btn'`}
                            startIcon='add'
                        >
                            New Hospital
                        </Button>
                    </div>	
				</div> 
				<div className='hospital-list-container'>
				<table className='table table-bordered  table-hover'>
					<thead className='hospital-table-container'>
							<HospitalTable data={hospitalsListQuery.data}/>
					</thead>
				</table>
				</div>
				{showAddHospital &&(
				<WrapperModal
					onDismiss={cancelCreationHandler}
					defaultWidth='1000px'
				>
					<NewHospitalForm
						title='Create New Hospital'
						subtitle='Please complete each input to add a new hospital'
						acceptLabel='Yes, create'
						declineLabel='No, review'
						onAccept={()=>{
							setConfirmationModal(true);
							setAddHospital(false);
						}}
						onDecline={cancelCreationHandler}

					/>

					
				</WrapperModal>
				)

				}
				{confirmationModal && (
					<WrapperModal
					onDismiss={cancelCreationHandler}
					>
						<ConfirmationWarning
						title={'The hospital was created successfully'}
						acceptLabel={'Continue'}
						declineLabel={'Close'}
						onAccept={()=>{setConfirmationModal(false)}}
						onDecline={()=>{setConfirmationModal(false)}}
						>
						</ConfirmationWarning>
					</WrapperModal>
				)}
			</div>
			
			
			
			
		</div>
	);
};
export default HospitalPage;
